import { render, staticRenderFns } from "./Districts.vue?vue&type=template&id=3bac2ac4&scoped=true&"
import script from "./Districts.vue?vue&type=script&lang=js&"
export * from "./Districts.vue?vue&type=script&lang=js&"
import style0 from "./Districts.vue?vue&type=style&index=0&id=3bac2ac4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac2ac4",
  null
  
)

component.options.__file = "Districts.vue"
export default component.exports